import { VALID_EDITION_BASENAMES } from '../constants';
import {includes, get} from 'lodash';

const EDITION_PATH_REG_EXP = '/([^/;]+)(.*)?';

/*
 * Given a pathname of `/en-us/2018/04/1234/article`,
 * this returns `/2018/04/1234/article`.
 * We return `/` when we are on a homepage, `/en-us`.
 */
export const getPathnameWithoutEditionBasename = (pathname) =>
  get(pathname.match(EDITION_PATH_REG_EXP), '[2]') || '/';

/*
 * Given a pathname of `/en-us/2018/04/1234/article`,
 * this returns `en-us`.
 */
export const getEditionBasename = (pathname) =>
  get(pathname.match(EDITION_PATH_REG_EXP), '[1]');


export const isEditionPathname = (pathname) =>
  includes(VALID_EDITION_BASENAMES, getEditionBasename(pathname));

export const getPathname = (pathname, editionID) => {

  return (isEditionPathname(pathname) || editionID)
    ? getPathnameWithoutEditionBasename(pathname)
    : pathname;
};
